import { Icon } from "@newsela/angelou";

import AiSparkIconSVG from "@/icons/AiSparkIcon/AiSparkIconSVG";
import { lunaAITagCss } from "./AILunaTag.style";
interface AILunaTagProps {
  enableHoverEffect?: boolean;
  textVersion?: "short" | "long" | "none";
}

export const AILunaTag = ({
  enableHoverEffect = false,
  textVersion = "short",
}: AILunaTagProps) => {
  const text =
    textVersion === "short"
      ? "LUNA"
      : textVersion === "long"
        ? "CREATED BY LUNA"
        : undefined;

  return (
    <span css={lunaAITagCss(enableHoverEffect)}>
      {text}
      <Icon
        SvgComponent={AiSparkIconSVG}
        size={Icon.sizes.sm}
        isDecorative={false}
        title="Luna AI Tag"
      />
    </span>
  );
};

AILunaTag.displayName = "AILunaTag";

export default AILunaTag;
